export const JORNAYA_INPUT_ID = 'leadid_token';
export const JORNAYA_DISCLOSURE_ID = 'leadid_tcpa_disclosure';

export const createJornayaInput = parentId => {
    const leadIdTokenInput = document.createElement('input');
    leadIdTokenInput.id = JORNAYA_INPUT_ID;
    leadIdTokenInput.name = 'universal_leadid';
    leadIdTokenInput.type = 'hidden';
    leadIdTokenInput.value = '';
    const container = document.getElementById(parentId);
    if (container) {
        container.appendChild(leadIdTokenInput);
    } else {
        document.body.appendChild(leadIdTokenInput);
    }
};

export const addJornayaScript = parentId => {
    // jornaya compliance script
    // https://marketing.verisk.com/helpcenter/docs/getting-started-with-create

    const script = document.createElement('script');
    script.id = 'LeadiDscript_campaign';
    script.type = 'text/javascript';
    script.async = true;
    script.src = '//create.lidstatic.com/campaign/3d2e98ad-519d-f0de-3c86-015895bb9611.js?snippet_version=2';

    const leadIdScript = document.getElementById(parentId);
    if (leadIdScript) {
        leadIdScript.parentNode.insertBefore(script, leadIdScript);
    } else {
        document.body.appendChild(script);
    }
};
